export default __webpack_public_path__ + "static/media/openshift.00da403d022ceff9dc3f8e030c62eaec.svg";